import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default () => {
  return (
    <SvgIcon>
      <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 200 200">
        <path
          d="M59.9,183c11.8,6.7,25.5,10.5,40.1,10.5c13.7,0,26.5-3.4,37.8-9.3l0,0c1.9-1.1,3.2-3.1,3.2-5.5c0-3.5-2.8-6.2-6.2-6.2
	c-1.1,0-2.1,0.3-3,0.8l0,0c-9.5,5-20.3,7.8-31.8,7.8c-12.4,0-24.1-3.3-34.1-9.1l0,0c-1-0.6-2.2-1-3.4-1c-3.5,0-6.2,2.8-6.2,6.2
	C56.2,179.8,57.8,182,59.9,183z M166.3,93.7L166.3,93.7c-3.8-13.4-11.5-25.1-21.8-33.9c-1.6-1.1-2.6-3-2.6-5.1
	c0-3.5,2.8-6.2,6.2-6.2c1.5,0,2.9,0.5,4,1.4l0,0c12.6,10.5,21.9,24.7,26.3,41c0.2,0.6,0.3,1.3,0.3,1.9c0,3.5-2.8,6.2-6.2,6.2
	C169.3,99.1,166.7,96.8,166.3,93.7L166.3,93.7z M21.8,90.3c4.5-16,13.8-30,26.2-40.3l0,0c1.1-0.9,2.5-1.4,3.9-1.4
	c3.5,0,6.2,2.8,6.2,6.2c0,2.1-1,4-2.6,5.1C45.1,68.7,37.4,80.5,33.7,94l0,0c-0.7,2.7-3.1,4.7-6.1,4.7c-3.5,0-6.2-2.8-6.2-6.2
	c0-0.3,0-0.5,0.1-0.8l0,0c0-0.1,0-0.2,0.1-0.3C21.5,91,21.6,90.6,21.8,90.3z M100,69c-17.3,0-31.2-14-31.2-31.2S82.7,6.5,100,6.5
	s31.2,14,31.2,31.2S117.3,69,100,69z M100,56.5c10.4,0,18.8-8.4,18.8-18.8S110.4,19,100,19s-18.8,8.4-18.8,18.8S89.6,56.5,100,56.5z
	M31.2,173.3C14,173.3,0,159.3,0,142.1s14-31.2,31.2-31.2s31.2,14,31.2,31.2S48.5,173.3,31.2,173.3z M31.2,160.8
	c10.4,0,18.8-8.4,18.8-18.8s-8.4-18.8-18.8-18.8s-18.8,8.4-18.8,18.8S20.9,160.8,31.2,160.8z M168.8,173.3
	c-17.3,0-31.2-14-31.2-31.2s14-31.2,31.2-31.2s31.2,14,31.2,31.2S186,173.3,168.8,173.3z M168.8,160.8c10.4,0,18.8-8.4,18.8-18.8
	s-8.4-18.8-18.8-18.8s-18.8,8.4-18.8,18.8S158.4,160.8,168.8,160.8z"
        />
      </svg>
    </SvgIcon>
  );
};
